import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { Button, Text, Avatar, Heading } from '../../';
import styled from '@emotion/styled';
import {
  InputText,
  TextArea,
  DropFile,
  Dropdown,
  ButtonRadio,
  TaskTypeOption,
  TaskMenu
} from '../../../components/form';
import Divider from '../../Divider';
import Icon from '../../Icon';
import cross from '../../../assets/images/cross.svg';
import GreenDropdown from '../../../assets/images/green-dropdown.svg';
import profile_pic from '../../../assets/images/profile_pic.png';
import PlusGreyBold from '../../../assets/images/plus-grey-bold.svg';
import AddProfilePic from '../../../assets/images/addProfilePic.svg';
import ChangeProfilePicModal from '../ChangeProfilePicModal';
import { useDispatch, useSelector } from 'react-redux';
import {
  REQUEST_EDITCLIENTADMINDATA,
  CLEAR_EDITCLIENTADMINDATA
} from '../../../constants/SuperAdmin/EditClientAdminConstants';
import { REQUEST_SUPERADMINDASHBOARD_DATA } from '../../../constants/SuperAdmin/SuperAdminDashboardConstants';
import { REQUEST_UPDATE_PASSWORD } from '../../../constants/SuperAdmin/UpdatedPasswordConstant';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './sucesstoast.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
const field = {
  marginLeft: '0px'
};

const InputTextContainer = styled.div`
  .iconContainer {
    position: absolute;
    top: 30%;
    right: 15px;
  }
  span {
    font-size: 18px;
    color: var(--greyBlue);
  }
`;

const SeeButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  line-height: 1;

  .reverse {
    transform: rotate(-180deg);
  }
`;
const CustomButton = styled(Button)`
  width: ${props => props.width};
  padding: 3px 3px !important;
  float: right;
  margin-right: 5px;
`;

const ErrorMsg = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
  margin-bottom: 8px;
`;

const Pill = styled.span`
  font-size: 9px;
  font-family: 'Readex Pro', sans-serif;
  padding: 0.5em 1em;
  margin: 0.25em;
  // border-radius: 1em;
  // border: none;
  // outline: none;
  // background: #dddddd;
  border-radius: 20px;
  cursor: pointer;
  border: 1px solid grey;
  font-weight: bold;
`;

const gender_list = [
  { value: 1, label: 'Male' },
  { value: 2, label: 'Female' },
  { value: 3, label: 'Non-Binary' }
];

const city_list = [
  { value: 1, label: 'Hyderabad' },
  { value: 2, label: 'Bangalore' },
  { value: 3, label: 'Mumbai' },
  { value: 4, label: 'Kolkata' },
  { value: 5, label: 'Delhi' }
];

const qualification_list = [
  { value: 1, label: 'Illiterate' },
  { value: 2, label: 'Literate but no formal schooling' },
  { value: 3, label: 'School (5-9 yrs)' },
  { value: 4, label: 'SSC/HSC' },
  { value: 5, label: 'Some College(Including a diploma but not graduate)' },
  { value: 6, label: 'Graduate/Post-Graduate: General' },
  { value: 7, label: 'Graduate/Post-Graduate: Professional' }
];

const subscription_list = [
  { value: 1, label: 'A30' },
  { value: 2, label: 'A50' },
  { value: 3, label: 'A100' },
  { value: 4, label: 'A400' }
];

const SeeLess = () => (
  <>
    See less <img src={GreenDropdown} className="ml-2" />
  </>
);

const SeeMore = () => (
  <>
    See more <img src={GreenDropdown} className="ml-2 reverse" />
  </>
);

export default function EditClientAdminModal({ clientAdminModaldata, setIsFlag, IsFlag, showModal, setShowModal }) {
  const [seeMoreProfile, setSeeMoreProfile] = useState(true);
  const [seeMoreLicense, setSeeMoreLicense] = useState(false);
  const [seeMoreBilling, setSeeMoreBilling] = useState(false);
  const [GetClientAdminData, setGetClientAdminData] = useState([]);

  const [editClientAdminData, setEditClientAdminData] = useState({});
  const modalRef = useRef(null);
  const isSubmittingRef = useRef(false);

  const dispatch = useDispatch();
  // const [userType, setUserType] = useState('');
  const clientAdminData = useSelector(state => state.EditClientAdminReducer.editClientAdminData);
  const currentStatus = useSelector(state => state.EditClientAdminReducer.editClientAdminDataRecived);

  useEffect(() => {
    setGetClientAdminData(clientAdminModaldata);
    // Clear errors when modal opens with new data
    setErrors({});
    setFieldErrors({});
  }, [clientAdminModaldata]);

  // Watch for API response and show appropriate toast
  useEffect(() => {
    if (isSubmittingRef.current && currentStatus !== null) {
      // Handle both old format (just number) and new format (object with Response and Status)
      const responseValue = typeof currentStatus === 'object' ? currentStatus?.Response : currentStatus;
      const statusCode = typeof currentStatus === 'object' ? currentStatus?.Status?.StatusCode : null;
      const statusDesc = typeof currentStatus === 'object' ? currentStatus?.Status?.StatusDesc : null;
      
      const isSuccess = responseValue === 1 || statusCode === "1" || statusCode === 1;
      
      if (isSuccess) {
        // Show status information in toast
        toast.success(
          <div style={{ display: 'flex', flexDirection: 'column', padding: '8px 0' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
              <FontAwesomeIcon
                icon={faCircleCheck}
                style={{ color: 'var(--primaryColor)', marginRight: '8px', fontSize: '1.5em' }}
              />
              <span>Client admin data updated successfully!</span>
            </div>
          </div>,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light', 
            style: { marginTop: '70px' },
            icon: false
          }
        );
        
        // Only call view/get API if edit API is successful
        dispatch({ type: REQUEST_SUPERADMINDASHBOARD_DATA });
        closeModal();
      } else {
        // Show error with status information
        toast.error(
          <div style={{ display: 'flex', flexDirection: 'column', padding: '8px 0' }}>
            <div>Failed to update client admin data. Please try again.</div>
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
            style: { marginTop: '70px' }
          }
        );
      }

      dispatch({ type: CLEAR_EDITCLIENTADMINDATA });
      isSubmittingRef.current = false;
    }
  }, [currentStatus, dispatch]);

  // Clear errors when modal closes
  useEffect(() => {
    if (!showModal) {
      setErrors({});
      setFieldErrors({});
      isSubmittingRef.current = false;
    }
  }, [showModal]);

  const closeModal = () => {
    $(modalRef.current).modal('hide');
    setShowModal(false);
  };

  // Initialize editClientAdminData only when modal opens with new data, not when GetClientAdminData changes
  // This prevents overwriting user input when they type in fields
  useEffect(() => {
    if (clientAdminModaldata) {
      const updatedData = {
        subscription_plan: clientAdminModaldata?.subscriptionPlan || ''
      };

      Object.keys(clientAdminModaldata).forEach(key => {
        const index = parseInt(key);
        if (!isNaN(index)) {
          updatedData[`fullname_${index}`] = clientAdminModaldata[key]?.name || '';
          updatedData[`designation_${index}`] = clientAdminModaldata[key]?.desigination || '';
          updatedData[`team_name_${index}`] = clientAdminModaldata[key]?.teamName || '';
          updatedData[`team_email_${index}`] = clientAdminModaldata[key]?.email || '';
          updatedData[`team_mobile_${index}`] = clientAdminModaldata[key]?.mobile || '';
          updatedData[`division_name_${index}`] = clientAdminModaldata[key]?.division || '';
          updatedData[`password_${index}`] = clientAdminModaldata[key]?.password || '1234';
        }
      });

      setEditClientAdminData(updatedData);
    }
  }, [clientAdminModaldata]);

  // const handleChange = (evt) => {
  //   const { name, value } = evt.target;
  //   setGetClientAdminData((prevData) => ({
  //     ...prevData,
  //     [name]: value
  //   }));
  // };

  const handleChange = evt => {
    const value = evt.target.value;
    setGetClientAdminData({
      ...GetClientAdminData,
      [evt.target.name]: value
    });
  };

  const handleLicenseChange = e => {
    const { name, value } = e.target;
    console.log('pass', name, value)
    setEditClientAdminData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };
console.log('ed', editClientAdminData)
  const handleSubscriptionChange = option => {
    //  console.log("option", option)
    setEditClientAdminData(prevData => ({
      ...prevData,
      subscription_plan: option.label
    }));
  };

  const change_password = () => {
    const user_id = GetClientAdminData?.user_id;

    dispatch({
      type: REQUEST_UPDATE_PASSWORD,
      payload: user_id
    });
  };

  // Function to check if a phone number is already used
  const checkDuplicatePhoneNumber = (phoneNumber, currentField) => {
    if (!phoneNumber) return false;

    const phoneNumberMap = {
      team_mobile_1: editClientAdminData.team_mobile_1,
      team_mobile_2: editClientAdminData.team_mobile_2,
      team_mobile_3: editClientAdminData.team_mobile_3
    };

    // Check for duplicates with other licenses
    for (const [field, number] of Object.entries(phoneNumberMap)) {
      if (field !== currentField && number === phoneNumber) {
        return `This phone number is already used in ${field.replace('team_mobile_', 'License ')}`;
      }
    }

    return false;
  };

  // Add state for field errors
  const [fieldErrors, setFieldErrors] = useState({});

  const validateLicenseFields = () => {
    const errors = {};

    // Validate License 1 (required)
    const license1Fields = {
      team_name_1: 'Team name',
      fullname_1: 'Full name',
      designation_1: 'Designation',
      team_email_1: 'Email',
      team_mobile_1: 'Phone number',
      division_name_1: 'Division name',
      password_1: 'password'
    };

    // Always validate License 1 as it's required
    Object.entries(license1Fields).forEach(([field, label]) => {
      if (!editClientAdminData[field]?.trim()) {
        errors[field] = `${label} is required for License 1`;
      }
    });

    // Validate License 1 phone number format and uniqueness
    if (editClientAdminData.team_mobile_1) {
      if (!/^\d{10}$/.test(editClientAdminData.team_mobile_1)) {
        errors.team_mobile_1 = 'Enter a valid 10-digit phone number for License 1';
      } else {
        const duplicateError = checkDuplicatePhoneNumber(editClientAdminData.team_mobile_1, 'team_mobile_1');
        if (duplicateError) {
          errors.team_mobile_1 = duplicateError;
        }
      }
    }

    // Validate License 1 email format
    if (editClientAdminData.team_email_1 && !/^\S+@\S+\.\S+$/.test(editClientAdminData.team_email_1)) {
      errors.team_email_1 = 'Enter a valid email for License 1';
    }

    // Validate License 2 and 3
    [2, 3].forEach(licenseNum => {
      const hasAnyValue = [
        `team_name_${licenseNum}`,
        `fullname_${licenseNum}`,
        `designation_${licenseNum}`,
        `team_email_${licenseNum}`,
        `team_mobile_${licenseNum}`,
        `division_name_${licenseNum}`,
         `password_${licenseNum}`,
      ].some(field => editClientAdminData[field]?.trim());

      if (hasAnyValue) {
        // If any field is filled, all fields are required
        const licenseFields = {
          [`team_name_${licenseNum}`]: 'Team name',
          [`fullname_${licenseNum}`]: 'Full name',
          [`designation_${licenseNum}`]: 'Designation',
          [`team_email_${licenseNum}`]: 'Email',
          [`team_mobile_${licenseNum}`]: 'Phone number',
          [`division_name_${licenseNum}`]: 'Division name',
          [`password_${licenseNum}`]: 'Password'
        };

        Object.entries(licenseFields).forEach(([field, label]) => {
          if (!editClientAdminData[field]?.trim()) {
            errors[field] = `${label} is required for License ${licenseNum}`;
          }
        });

        // Validate phone number format and uniqueness
        const mobileField = `team_mobile_${licenseNum}`;
        if (editClientAdminData[mobileField]) {
          if (!/^\d{10}$/.test(editClientAdminData[mobileField])) {
            errors[mobileField] = `Enter a valid 10-digit phone number for License ${licenseNum}`;
          } else {
            const duplicateError = checkDuplicatePhoneNumber(editClientAdminData[mobileField], mobileField);
            if (duplicateError) {
              errors[mobileField] = duplicateError;
            }
          }
        }

        // Validate email format
        const emailField = `team_email_${licenseNum}`;
        if (editClientAdminData[emailField] && !/^\S+@\S+\.\S+$/.test(editClientAdminData[emailField])) {
          errors[emailField] = `Enter a valid email for License ${licenseNum}`;
        }
      }
    });

    // Update field errors state
    setFieldErrors(errors);

    return Object.keys(errors).length === 0;
  };
  const [errors, setErrors] = useState({});

  const validate = () => {
    console.log('Starting validation...');
    console.log('Current editClientAdminData:', editClientAdminData);
    const nextErrors = {};

    // Function to check if a phone number is already used
    const checkDuplicatePhoneNumber = (phoneNumber, currentField) => {
      if (!phoneNumber) return false;

      const phoneNumberMap = {
        team_mobile_1: editClientAdminData.team_mobile_1,
        team_mobile_2: editClientAdminData.team_mobile_2,
        team_mobile_3: editClientAdminData.team_mobile_3
      };

      // Check for duplicates with other licenses
      for (const [field, number] of Object.entries(phoneNumberMap)) {
        if (field !== currentField && number === phoneNumber) {
          return `This phone number is already used in ${field.replace('team_mobile_', 'License ')}`;
        }
      }

      return false;
    };
    console.log('editClientAdminData',editClientAdminData)

    // License 1 required fields (always required)
    const license1Fields = {
      team_name_1: 'Team name',
      fullname_1: 'Full name',
      designation_1: 'Designation',
      team_email_1: 'Email',
      team_mobile_1: 'Phone number',
      division_name_1: 'Division name',
      password_1: 'Password'
    };

    // Validate License 1 (required)
    Object.entries(license1Fields).forEach(([field, label]) => {
      if (!editClientAdminData[field]?.trim()) {
        nextErrors[field] = `${label} is required for License 1`;
      }
    });

    // Validate License 1 email format
    if (editClientAdminData.team_email_1 && !/^\S+@\S+\.\S+$/.test(editClientAdminData.team_email_1)) {
      nextErrors.team_email_1 = 'Enter a valid email for License 1';
    }

    // Validate phone numbers for all licenses
    ['team_mobile_1', 'team_mobile_2', 'team_mobile_3'].forEach((field, index) => {
      const phoneNumber = editClientAdminData[field];
      if (phoneNumber) {
        // Check phone number format
        if (!/^\d{10}$/.test(phoneNumber)) {
          nextErrors[field] = `Enter a valid 10-digit phone number for License ${index + 1}`;
        } else {
          // Check for duplicate phone numbers
          const duplicateError = checkDuplicatePhoneNumber(phoneNumber, field);
          if (duplicateError) {
            nextErrors[field] = duplicateError;
          }
        }
      }
    });

    // License 2 validation - if any field is filled, all become required
    const license2Fields = {
      team_name_2: 'Team name',
      fullname_2: 'Full name',
      designation_2: 'Designation',
      team_email_2: 'Email',
      team_mobile_2: 'Phone number',
      division_name_2: 'Division name',
      password_2: 'Password'
    };

    const hasLicense2Data = Object.keys(license2Fields).some(field => editClientAdminData[field]?.trim());
    if (hasLicense2Data) {
      Object.entries(license2Fields).forEach(([field, label]) => {
        if (!editClientAdminData[field]?.trim()) {
          nextErrors[field] = `${label} is required for License 2`;
        }
      });

      // Validate License 2 email format
      if (editClientAdminData.team_email_2 && !/^\S+@\S+\.\S+$/.test(editClientAdminData.team_email_2)) {
        nextErrors.team_email_2 = 'Enter a valid email for License 2';
      }
    }

    // License 3 validation - if any field is filled, all become required
    const license3Fields = {
      team_name_3: 'Team name',
      fullname_3: 'Full name',
      designation_3: 'Designation',
      team_email_3: 'Email',
      team_mobile_3: 'Phone number',
      division_name_3: 'Division name',
      password_3: 'Password'

    };

    const hasLicense3Data = Object.keys(license3Fields).some(field => editClientAdminData[field]?.trim());
    if (hasLicense3Data) {
      Object.entries(license3Fields).forEach(([field, label]) => {
        if (!editClientAdminData[field]?.trim()) {
          nextErrors[field] = `${label} is required for License 3`;
        }
      });

      // Validate License 3 email format
      if (editClientAdminData.team_email_3 && !/^\S+@\S+\.\S+$/.test(editClientAdminData.team_email_3)) {
        nextErrors.team_email_3 = 'Enter a valid email for License 3';
      }
    }

    setErrors(nextErrors);
    console.log('Validation errors:', nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const editClientAdmin = () => {
    if (!validate()) {
      return;
    }
    const originalSubscriptionPlan = GetClientAdminData?.subscriptionPlan;
    const currentSubscriptionPlan = editClientAdminData?.subscription_plan;
    const finalSubscriptionPlan =
      currentSubscriptionPlan !== originalSubscriptionPlan ? currentSubscriptionPlan : originalSubscriptionPlan;

    // Generate license array with only licenses that have meaningful data
    const licenses = [1, 2, 3].map(index => {
        // Get original license data
        console.log('Processing license index:', index);
        console.log('Original license data:', GetClientAdminData[index]);
        console.log('Current edited data for this license:', {
          fullname: editClientAdminData[`fullname_${index}`],
          teamName: editClientAdminData[`team_name_${index}`],
          email: editClientAdminData[`team_email_${index}`],
          phone: editClientAdminData[`team_mobile_${index}`],
          designation: editClientAdminData[`designation_${index}`],
          division: editClientAdminData[`division_name_${index}`],
          password: editClientAdminData[`password_${index}`]
        });
        const originalLicense = GetClientAdminData[index] || {};
        
        // Get edited or original values
        const fullName = editClientAdminData[`fullname_${index}`] || originalLicense.name || '';
        const teamName = editClientAdminData[`team_name_${index}`] || originalLicense.teamName || '';
        const email = editClientAdminData[`team_email_${index}`] || originalLicense.email || '';
        const phone = editClientAdminData[`team_mobile_${index}`] || originalLicense.mobile || '';
        const designation = editClientAdminData[`designation_${index}`] || originalLicense.desigination || '';
        const division = editClientAdminData[`division_name_${index}`] || originalLicense.division || '';
        const password = editClientAdminData[`password_${index}`] || '1234';
        
        const license = {
            FullName: fullName,
            TeamName: teamName,
            email: email,
            phone: phone,
            desigination: designation,
            identity_id: `${index}`,
            division: division,
            id: originalLicense.id || '',
            ClientTeam_ID: originalLicense.client_ID || '',
            password: password
        };

        // Check if this license has meaningful data
        // For License 1, it's always required, so always include if it has required fields
        // For License 2 and 3, only include if they have actual data (not just defaults/empty)
        if (index === 1) {
            // License 1: Check if required fields are filled
            const hasRequiredFields = fullName.trim() && teamName.trim() && email.trim() && phone.trim() && designation.trim() && division.trim();
            return hasRequiredFields ? license : null;
        } else {
            // License 2 and 3: Only include if they have meaningful data (not just default password or empty values)
            const hasMeaningfulData = (fullName.trim() || teamName.trim() || email.trim() || phone.trim() || designation.trim() || division.trim());
            return hasMeaningfulData ? license : null;
        }
    }).filter(license => license !== null); // Remove null entries

    const formData = {
      user_id: GetClientAdminData?.user_id,
      name: GetClientAdminData?.name,
      Client_ID: GetClientAdminData?.client_ID,
      CompanyName: GetClientAdminData?.clientsName,
      email: GetClientAdminData?.email,
      mobile: GetClientAdminData?.mobile,
      password: '1234',
      city: GetClientAdminData?.city,
      pincode: GetClientAdminData?.pincode,
      address: GetClientAdminData?.address,
      subscription_plan: finalSubscriptionPlan,
      validFrom: GetClientAdminData?.validFrom,
      validTo: GetClientAdminData?.validTo,
      HoursAllocated: '4',
      accountName: GetClientAdminData.accountName,
      accountNumber: GetClientAdminData.accountNumber,
      branchName: GetClientAdminData.branchName,
      swiftCode: GetClientAdminData.swiftCode,
      sortCode: GetClientAdminData.sortCode,
      IFSCCode: GetClientAdminData.IFSCCode,
      license: licenses // Ensure license array contains ClientTeam_ID
    };
    
    // Set flag to indicate we're submitting
    isSubmittingRef.current = true;
    
    dispatch({
      type: REQUEST_EDITCLIENTADMINDATA,
      payload: formData
    });

    // setIsFlag(0);
  };

  return (
    <div>
      {showModal && (
        <>
          <div
            className="modal fade"
            id="editClientAdminModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
            ref={modalRef}
          >
            <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: '700px' }}>
              <div className="modal-content" style={{ borderRadius: '10px' }}>
                <div className="modal-header border-0">
                  <Text>
                    <Pill className="mt-2 ml-2">
                      {' '}
                      {GetClientAdminData?.clientsName}
                      <img src={cross} className="ml-1 mb-1" style={{ cursor: 'pointer', borderRadius: '50%' }} />
                    </Pill>
                  </Text>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="container">
                    <div className="row">
                      <div className="col-1" data-toggle="modal" data-target="#changeProfilePicModal">
                        {/* <img src={AddProfilePic} style={{ position: 'absolute', marginTop: '45px' }} /> */}
                        <Avatar className="team-profile-pic" width="60" height="60" />
                      </div>
                      <div className="container w-75">
                        <div className="row">
                          {/* Profile Details */}
                          <div>
                            <Heading fontSize="14px" className="mt-3 ml-3">
                              Profile
                            </Heading>
                            {seeMoreProfile == true ? (
                              <>
                                <InputTextContainer>
                                  <div className="row" style={field}>
                                    <div className="col-8">
                                      <InputText
                                        name="name"
                                        placeholder="Name"
                                        showCharacters={false}
                                        defaultValue={GetClientAdminData?.name}
                                        value={GetClientAdminData?.name}
                                        onChange={handleChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      <Icon className="iconContainer">create</Icon>
                                    </div>
                                    <div className="col-4">
                                      <InputText
                                        name="mobile"
                                        placeholder="Phone No."
                                        showCharacters={false}
                                        value={GetClientAdminData?.mobile}
                                        onChange={handleChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      <Icon className="iconContainer">create</Icon>
                                    </div>
                                  </div>
                                  <div className="row" style={field}>
                                    <div className="col-8">
                                      <InputText
                                        name="email"
                                        placeholder="Email"
                                        showCharacters={false}
                                        value={GetClientAdminData?.email}
                                        onChange={handleChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      <Icon className="iconContainer">create</Icon>
                                    </div>
                                  </div>
                                  {/* ///// reset password */}
                                  <div className="row" id="ResetPassword">
                                    <div className="col col-5 mt-2 mb-2 ml-1">
                                      <CustomButton
                                        className="ml-0"
                                        size="small"
                                        variant="outlined"
                                        fontSize="8px"
                                        data-toggle="modal"
                                        data-target="#ResetPasswordClientAdmin"
                                        style={{
                                          paddingLeft: '20px',
                                          marginRight: '85px',
                                          borderRadius: '7px',
                                          height: '20px',
                                          width: '85px'
                                        }}
                                        onClick={change_password}
                                      >
                                        Reset Passwords
                                      </CustomButton>
                                      {/* New Modal for Reset Password  */}
                                      <div
                                        className="modal fade"
                                        id="ResetPasswordClientAdmin"
                                        tabindex="-1"
                                        role="dialog"
                                        aria-labelledby="exampleModalCenterTitle"
                                        aria-hidden="true"
                                      >
                                        <div
                                          className="modal-dialog modal-dialog-centered "
                                          role="document"
                                          style={{ width: '400px' }}
                                        >
                                          <div className="modal-content" style={{ borderRadius: '10px' }}>
                                            <div className="modal-header border-0">
                                              <Heading fontSize="18px">Reset Your Password</Heading>
                                              {/* <button type="button" className="close" data-dismiss="modal" data-target='#DeleteModal' aria-label="Close">
                                                                                        <span aria-hidden="true">&times;</span>
                                                                                    </button> */}
                                            </div>
                                            <div className="modal-body border-0" style={{ paddingBottom: '20px' }}>
                                              <div className="row mb-2">
                                                <div className="col col-12">
                                                  <Text type="3" color="var(--ternaryColor)" className="mb-0">
                                                    We sent a reset password email to {GetClientAdminData?.email}.
                                                    Please click the reset password link to set your new password.
                                                  </Text>
                                                </div>
                                              </div>
                                              <div className="row" style={{ paddingTop: '20px' }}>
                                                <div id="delete" className="col col-3">
                                                  <CustomButton
                                                    className="ml-1 mt-1"
                                                    size="small"
                                                    // variant='outlined'
                                                    width="60px"
                                                    data-dismiss="modal"
                                                    // style={{ color: "#798E8F", background: "none" }}
                                                  >
                                                    Done
                                                  </CustomButton>
                                                </div>
                                                <div
                                                  id="resendEmail"
                                                  className="col col-8 col-offset-6"
                                                  style={{ display: 'flex', justifyContent: 'end' }}
                                                >
                                                  <Text
                                                    type="3"
                                                    color="var(--ternaryColor)"
                                                    fontSize="10px"
                                                    className="mt-2"
                                                  >
                                                    <u>Resend Email</u>
                                                  </Text>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      {/* END */}
                                    </div>
                                  </div>
                                  {/* ///////////////////// */}
                                  <div className="row" style={field}>
                                    <div className="col-8">
                                      <InputText
                                        name="clientsName"
                                        placeholder="Company name"
                                        showCharacters={false}
                                        onChange={handleChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={GetClientAdminData?.clientsName}
                                        // value='Rohit Nimbalkar'
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      <Icon className="iconContainer">create</Icon>
                                    </div>
                                  </div>
                                  <div className="row" style={field}>
                                    <div className="col-12">
                                      <InputText
                                        name="address"
                                        placeholder="Company Address"
                                        showCharacters={false}
                                        value={GetClientAdminData?.address}
                                        onChange={handleChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      <Icon className="iconContainer">create</Icon>
                                    </div>
                                  </div>
                                  <div className="row" style={field}>
                                    <div className="col-8">
                                      <Dropdown
                                        name="city"
                                        placeholder={GetClientAdminData?.city}
                                        showCharacters={false}
                                        options={city_list}
                                        selected={GetClientAdminData?.city}
                                        // onChange={(evt) =>
                                        //     //  console.warn(evt.label)
                                        //     setGetClientAdminData({
                                        //         ...GetClientAdminData,
                                        //         'city': evt.label
                                        //     })
                                        // }
                                        onChange={handleChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        // value={GetClientAdminData?.city}
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                    </div>
                                    <div className="col-4">
                                      <InputText
                                        name="pincode"
                                        placeholder="Pincode"
                                        showCharacters={false}
                                        value={GetClientAdminData?.pincode}
                                        onChange={handleChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      <Icon className="iconContainer">create</Icon>
                                    </div>
                                  </div>
                                </InputTextContainer>
                              </>
                            ) : null}
                          </div>
                          {/* END */}
                        </div>
                        {/* See more Button */}
                        <SeeButton
                          className="mt-4"
                          simple
                          color="var(--primaryColor)"
                          fontSize="0.875rem"
                          fontWeight="500"
                          onClick={() => setSeeMoreProfile(!seeMoreProfile)}
                        >
                          {seeMoreProfile ? SeeLess() : SeeMore()}
                        </SeeButton>
                        {/* END */}

                        <Divider margin="0" height="2px" width="103%" color="#38454F" className="mt-2" />

                        <div className="">
                          {/* Primary Earning Member Details */}
                          <div>
                            <div className="row">
                              <div className="col-6">
                                <Heading fontSize="14px" className="mt-3">
                                  Licenses & Subscription
                                </Heading>
                              </div>
                              <div className="col-6 d-flex" style={{ justifyContent: 'end' }}>
                                <Heading fontSize="12px" className="mt-3 ml-3">
                                  <img src={PlusGreyBold} width="20px" height="15px" className="mr-1 mb-1" />
                                  Add License
                                </Heading>
                              </div>
                            </div>
                            {seeMoreLicense == true ? (
                              <>
                                <InputTextContainer>
                                  <div className="row" style={field}>
                                    <div className="col-4 mt-3 mb-3">
                                      <Text type="7">License 1</Text>
                                    </div>
                                    <div className="col-4 mt-3 mb-3">
                                      <Text type="7">License 2</Text>
                                    </div>
                                    <div className="col-4 mt-3 mb-3">
                                      <Text type="7">License 3</Text>
                                    </div>
                                  </div>
                                  <div className="row" style={field}>
                                    <div className="col-4">
                                        <InputText
                                          name="team_name_1"
                                          placeholder="Team name"
                                          showCharacters={false}
                                          onChange={handleLicenseChange}
                                          setIsFlag={setIsFlag}
                                          IsFlag={IsFlag}
                                          value={editClientAdminData['team_name_1'] || ''}
                                        />
                                        {errors.team_name_1 && <ErrorMsg>{errors.team_name_1}</ErrorMsg>}
                                        {/* <Icon className='iconContainer'>create</Icon> */}
                                    </div>
                                    <div className="col-4">
                                      <InputText
                                        name="team_name_2"
                                        placeholder="Team name"
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={editClientAdminData['team_name_2'] || ''}
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                      {errors.team_name_2 && <ErrorMsg>{errors.team_name_2}</ErrorMsg>}
                                    </div>
                                    <div className="col-4">
                                      <InputText
                                        name="team_name_3"
                                        placeholder="Team name"
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={editClientAdminData['team_name_3'] || ''}
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                      {errors.team_name_3 && <ErrorMsg>{errors.team_name_3}</ErrorMsg>}
                                    </div>
                                  </div>
                                  <div className="row" style={field}>
                                    <div className="col-4">
                                      <InputText
                                        name="fullname_1"
                                        placeholder="Full name"
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={editClientAdminData['fullname_1'] || ''}
                                        // value='Bussiness'
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                      {errors.fullname_1 && <ErrorMsg>{errors.fullname_1}</ErrorMsg>}
                                    </div>
                                    <div className="col-4">
                                      <InputText
                                        name="fullname_2"
                                        placeholder="Full name"
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={editClientAdminData['fullname_2'] || ''}
                                        // value='Bussiness'
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                      {errors.fullname_2 && <ErrorMsg>{errors.fullname_2}</ErrorMsg>}
                                    </div>
                                    <div className="col-4">
                                      <InputText
                                        name="fullname_3"
                                        placeholder="Full name"
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={editClientAdminData['fullname_3'] || ''}
                                        // value='Bussiness'
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                      {errors.fullname_3 && <ErrorMsg>{errors.fullname_3}</ErrorMsg>}
                                    </div>
                                  </div>
                                  <div className="row" style={field}>
                                    <div className="col-4">
                                      <InputText
                                        name="designation_1"
                                        placeholder="Designation"
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={editClientAdminData['designation_1'] || ''}
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you've missed this'
                                      />
                                      {errors.designation_1 && <ErrorMsg>{errors.designation_1}</ErrorMsg>}
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                    </div>
                                    <div className="col-4">
                                      <InputText
                                        name="designation_2"
                                        placeholder="Designation"
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={editClientAdminData['designation_2'] || ''}
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you've missed this'
                                      />
                                      {errors.designation_2 && <ErrorMsg>{errors.designation_2}</ErrorMsg>}
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                    </div>
                                    <div className="col-4">
                                      <InputText
                                        name="designation_3"
                                        placeholder="Designation"
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={editClientAdminData['designation_3'] || ''}
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you've missed this'
                                      />
                                      {errors.designation_3 && <ErrorMsg>{errors.designation_3}</ErrorMsg>}
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                    </div>
                                  </div>
                                  <div className="row" style={field}>
                                    <div className="col-4">
                                      <InputText
                                        name="team_email_1"
                                        placeholder="Email ID"
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={editClientAdminData['team_email_1'] || ''}
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you've missed this'
                                      />
                                      {errors.team_email_1 && <ErrorMsg>{errors.team_email_1}</ErrorMsg>}
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                    </div>
                                    <div className="col-4">
                                      <InputText
                                        name="team_email_2"
                                        placeholder="Email ID"
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={editClientAdminData['team_email_2'] || ''}
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you've missed this'
                                      />
                                      {errors.team_email_2 && <ErrorMsg>{errors.team_email_2}</ErrorMsg>}
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                    </div>
                                    <div className="col-4">
                                      <InputText
                                        name="team_email_3"
                                        placeholder="Email ID"
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={editClientAdminData['team_email_3'] || ''}
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you've missed this'
                                      />
                                      {errors.team_email_3 && <ErrorMsg>{errors.team_email_3}</ErrorMsg>}
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                    </div>
                                  </div>
                                  <div className="row" style={field}>
                                    <div className="col-4">
                                      <InputText
                                        name="team_mobile_1"
                                        placeholder="Phone no."
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={editClientAdminData['team_mobile_1'] || ''}
                                        // value='Bussiness'
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you've missed this'
                                      />
                                      {errors.team_mobile_1 && <ErrorMsg>{errors.team_mobile_1}</ErrorMsg>}
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                    </div>
                                    <div className="col-4">
                                      <InputText
                                        name="team_mobile_2"
                                        placeholder="Phone no."
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={editClientAdminData['team_mobile_2'] || ''}
                                      />
                                      {fieldErrors.team_mobile_2 && <ErrorMsg>{fieldErrors.team_mobile_2}</ErrorMsg>}
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                    </div>
                                    <div className="col-4">
                                      <InputText
                                        name="team_mobile_3"
                                        placeholder="Phone no."
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={editClientAdminData['team_mobile_3'] || ''}
                                      />
                                      {fieldErrors.team_mobile_3 && <ErrorMsg>{fieldErrors.team_mobile_3}</ErrorMsg>}
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                    </div>
                                  </div>
                                  <div className="row" style={field}>
                                    <div className="col-4">
                                      <InputText
                                        name="division_name_1"
                                        placeholder="Division Name"
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={editClientAdminData['division_name_1'] || ''}
                                        // value='Bussiness'
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you've missed this'
                                      />
                                      {errors.division_name_1 && <ErrorMsg>{errors.division_name_1}</ErrorMsg>}
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                    </div>
                                    <div className="col-4">
                                      <InputText
                                        name="division_name_2"
                                        placeholder="Division Name"
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={editClientAdminData['division_name_2'] || ''}
                                        // value='Bussiness'
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you've missed this'
                                      />
                                      {errors.division_name_2 && <ErrorMsg>{errors.division_name_2}</ErrorMsg>}
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                    </div>
                                    <div className="col-4">
                                      <InputText
                                        name="division_name_3"
                                        placeholder="Division Name"
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={editClientAdminData['division_name_3'] || ''}
                                        // value='Bussiness'
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you've missed this'
                                      />
                                      {errors.division_name_3 && <ErrorMsg>{errors.division_name_3}</ErrorMsg>}
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                    </div>
                                  </div>
                                  <div className='row' style={field}>
                                    <div className='col-4'>
                                      <InputText
                                        name='password_1'
                                        placeholder='password'
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        value={editClientAdminData['password_1'] || ''}
                                      />
                                       {errors.password_1 && <ErrorMsg>{errors.password_1}</ErrorMsg>}

                                    </div>
                                    <div className='col-4'>
                                      <InputText
                                        name='password_2'
                                        placeholder='password'
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        value={editClientAdminData['password_2'] || ''}
                                      />
                                      {errors.password_2 && <ErrorMsg>{errors.password_2}</ErrorMsg>}
                                    </div>
                                    <div className='col-4'>
                                      <InputText
                                        name='password_3'
                                        placeholder='password'
                                        showCharacters={false}
                                        onChange={handleLicenseChange}
                                        value={editClientAdminData['password_3'] || ''}
                                      />
                                        {errors.password_3 && <ErrorMsg>{errors.password_3}</ErrorMsg>}
                                    </div>
                                  </div> 
                                  <div className="row mt-4" style={field}>
                                    <div className="col-6">
                                      <Dropdown
                                        name="subscription_plan"
                                        placeholder={editClientAdminData.subscription_plan}
                                        showCharacters={true}
                                        options={subscription_list}
                                        selected={editClientAdminData.subscription_plan}
                                        onChange={handleSubscriptionChange}
                                        value={editClientAdminData.subscription_plan}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                        selectedFontWeight="60"
                                        selectedFontSize="medium !important"
                                        selectedColor="#757c7cd9 !important"
                                      />
                                      {/* <Icon className='iconContainer'>create</Icon> */}
                                    </div>
                                    <div className="col-1"></div>
                                    <div className="col-5 mt-2 d-flex" style={{ justifyContent: 'end' }}>
                                      <Text type="7">Subscription Status: Active</Text>
                                    </div>
                                  </div>
                                  <div className="row mt-2" style={field}>
                                    <div className="col-6 mt-2">
                                      <Text type="7">Hours used: 0 hrs</Text>
                                    </div>
                                    <div className="col-1"></div>
                                    <div className="col-5 mt-2 d-flex" style={{ justifyContent: 'end' }}>
                                      <Text type="7">Hours Left: 0 hrs</Text>
                                    </div>
                                  </div>

                                  <div className="row mt-3" style={field}>
                                    <div className="col-6 mt-2">
                                      <Text type="7">Period of Subscription : </Text>
                                    </div>
                                  </div>
                                  <div className="row" style={field}>
                                    <div className="col-6">
                                      <text style={{ fontSize: '10px' }}>
                                        <strong>Valid from : </strong>
                                        <input
                                          type="date"
                                          style={{
                                            boxShadow: 'inset 0px 0px 2px 1.5px rgb(0 0 0 / 15%)',
                                            width: '120px',
                                            borderRadius: '3px',
                                            border: 'navajowhite'
                                          }}
                                          name="validFrom"
                                          onChange={handleChange}
                                          setIsFlag={setIsFlag}
                                          IsFlag={IsFlag}
                                          value={GetClientAdminData?.validFrom}
                                        />
                                      </text>
                                    </div>
                                    <div className="col-1"></div>
                                    <div className="col-5 mt-1 d-flex" style={{ justifyContent: 'end' }}>
                                      <text style={{ fontSize: '10px' }}>
                                        <strong>Valid till : </strong>
                                        <input
                                          type="date"
                                          style={{
                                            boxShadow: 'inset 0px 0px 2px 1.5px rgb(0 0 0 / 15%)',
                                            width: '120px',
                                            borderRadius: '3px',
                                            border: 'navajowhite'
                                          }}
                                          name="validTo"
                                          onChange={handleChange}
                                          setIsFlag={setIsFlag}
                                          IsFlag={IsFlag}
                                          value={GetClientAdminData?.validTo}
                                        />
                                      </text>
                                    </div>
                                  </div>
                                </InputTextContainer>
                              </>
                            ) : null}
                          </div>
                          {/* END */}
                        </div>
                        {/* See more Button */}
                        <SeeButton
                          className="mt-4"
                          simple
                          color="var(--primaryColor)"
                          fontSize="0.875rem"
                          fontWeight="500"
                          onClick={() => setSeeMoreLicense(!seeMoreLicense)}
                        >
                          {seeMoreLicense ? SeeLess() : SeeMore()}
                        </SeeButton>
                        {/* END */}

                        <Divider margin="0" height="2px" width="103%" color="#38454F" className="mt-2" />

                        <div className="row">
                          {/* Billing Details */}
                          <div>
                            <Heading fontSize="14px" className="mt-3 ml-3">
                              Billing & Payments Info
                            </Heading>
                            {seeMoreBilling == true ? (
                              <>
                                <InputTextContainer>
                                  <div className="row" style={field}>
                                    <div className="col-6">
                                      <InputText
                                        name="accountName"
                                        placeholder="Account name"
                                        showCharacters={false}
                                        onChange={handleChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={GetClientAdminData?.accountName}
                                        // value='Rohit Nimbalkar'
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      <Icon className="iconContainer">create</Icon>
                                    </div>
                                    <div className="col-6">
                                      <InputText
                                        name="accountNumber"
                                        placeholder="Account Number"
                                        showCharacters={false}
                                        // onChange={handleChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}

                                        // value='7894563210'
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      <Icon className="iconContainer">create</Icon>
                                    </div>
                                  </div>
                                  <div className="row" style={field}>
                                    <div className="col-6">
                                      <InputText
                                        name="bank_name"
                                        placeholder="Select Bank"
                                        showCharacters={false}
                                        // onChange={handleChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        // value='Rohit Nimbalkar'
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      <Icon className="iconContainer">create</Icon>
                                    </div>
                                    <div className="col-6">
                                      <InputText
                                        name="branchName"
                                        placeholder="Branch Name"
                                        showCharacters={false}
                                        // onChange={handleChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        // value='7894563210'
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      <Icon className="iconContainer">create</Icon>
                                    </div>
                                  </div>
                                  <div className="row" style={field}>
                                    <div className="col-6">
                                      <InputText
                                        name="swiftCode"
                                        placeholder="Swift Code"
                                        showCharacters={false}
                                        // onChange={handleChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        // value='Rohit Nimbalkar'
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      <Icon className="iconContainer">create</Icon>
                                    </div>
                                    <div className="col-6">
                                      <InputText
                                        name="sortCode"
                                        placeholder="Sort Code"
                                        showCharacters={false}
                                        // onChange={handleChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}

                                        // value='7894563210'
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      <Icon className="iconContainer">create</Icon>
                                    </div>
                                  </div>
                                  <div className="row" style={field}>
                                    <div className="col-6">
                                      <InputText
                                        name="IFSCCode"
                                        placeholder="IFSC Code"
                                        showCharacters={false}
                                        onChange={handleChange}
                                        setIsFlag={setIsFlag}
                                        IsFlag={IsFlag}
                                        value={GetClientAdminData?.IFSCCode}
                                        // value='Rohit Nimbalkar'
                                        // showIcon={true}
                                        // iconName="create"
                                        // error='Hey, looks like you’ve missed this'
                                      />
                                      <Icon className="iconContainer">create</Icon>
                                    </div>
                                  </div>
                                </InputTextContainer>
                              </>
                            ) : null}
                          </div>
                          {/* END */}
                        </div>
                        {/* See more Button */}
                        <SeeButton
                          className="mt-4"
                          simple
                          color="var(--primaryColor)"
                          fontSize="0.875rem"
                          fontWeight="500"
                          onClick={() => setSeeMoreBilling(!seeMoreBilling)}
                        >
                          {seeMoreBilling ? SeeLess() : SeeMore()}
                        </SeeButton>
                        {/* END */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer border-0"></div>
                {/* <div className='container-fluid'> */}
                <div className="row">
                  <div className="col-3 modal-footer border-0 ml-4" style={{ justifyContent: 'flex-start' }}>
                    <CustomButton
                      className="ml-2 mt-1"
                      size="small"
                      // variant='outlined'
                      width="60px"
                      //  data-dismiss="modal"
                      // style={{ color: "#798E8F", background: "none" }}
                      onClick={editClientAdmin}
                    >
                      Save
                    </CustomButton>

                    <CustomButton
                      className="ml-2 mt-1"
                      size="small"
                      variant="outlined"
                      width="60px"
                      data-dismiss="modal"
                      // style={{ color: "#798E8F", background: "none" }}
                    >
                      Cancel
                    </CustomButton>
                  </div>
                  {/* <div className='col-8'>
                                    <CustomButton
                                        className='ml-2 mt-3'
                                        size='small'
                                        variant='outlined'
                                        width='60px'
                                        data-toggle="modal" data-target="#DeleteModalRespondant" data-dismiss="modal"
                                    // style={{ color: "#798E8F", background: "none" }}
                                    >
                                        Delete
                                    </CustomButton>
                                </div> */}
                </div>
                {/* </div> */}
              </div>
            </div>
          </div>

          {/* New Modal for Delete User  */}
          <div
            className="modal fade"
            id="DeleteModalRespondant"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered " role="document" style={{ width: '400px' }}>
              <div className="modal-content" style={{ borderRadius: '10px' }}>
                <div className="modal-header border-0" style={{ paddingBottom: '0px' }}>
                  <Heading fontSize="18px">Confirm Delete</Heading>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    data-target="#DeleteModal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body border-0" style={{ paddingBottom: '20px' }}>
                  <div className="row">
                    <div className="col col-12">
                      <Text type="7" color="var(--ternaryColor)" className="mb-0">
                        Are you sure you want to delete this Respondent?
                      </Text>
                    </div>
                  </div>
                  <div className="row" style={{ paddingTop: '20px' }}>
                    <div className="col">
                      <CustomButton
                        className="ml-2 mt-1"
                        size="small"
                        variant="outlined"
                        width="60px"
                        // width='5px'
                        // height='4px'
                        fontSize="10px"
                        style={{ float: 'left' }}
                        data-dismiss="modal"
                      >
                        Cancel
                      </CustomButton>
                    </div>
                    <div id="delete" className="col col-4 col-offset-6">
                      <CustomButton
                        className="ml-2 mt-1"
                        size="small"
                        // variant='outlined'
                        width="60px"
                        data-toggle="modal"
                        data-target="#UserDeletedModal"
                        data-dismiss="modal"
                        // style={{ color: "#798E8F", background: "none" }}
                      >
                        Delete
                      </CustomButton>
                    </div>
                  </div>
                </div>
                {/* <div className="modal-footer border-0">
                                <div className='row'>
                                    <div className='col col-4 col-offset-6'>
                                        <Button
                                            className='ml-4'
                                            size='small'
                                            variant='outlined'
                                            width='20px'

                                        >
                                            save changes
                                        </Button>
                                    </div>
                                </div>
                            </div> */}
              </div>
            </div>
          </div>

          {/* END */}
          <ToastContainer hideProgressBar={true} />
          {/* New Modal for change Profile picture */}
          <ChangeProfilePicModal />
          {/* END */}
        </>
      )}
    </div>
  );
}
